import { ILink } from '../types';
import { BASE_LINKS, ADDITIONAL_LINKS, CAREER_LINK } from '../constants';

interface IGetLinksListParameters {
  withAdditionalLinks: boolean;
}

export function getLinksList({ withAdditionalLinks }: IGetLinksListParameters): ILink[] {
  return withAdditionalLinks ? [...BASE_LINKS, ...ADDITIONAL_LINKS, CAREER_LINK] : [...BASE_LINKS, CAREER_LINK];
}
